import { createReducer, createActions } from 'reduxsauce';

export const DRAG_ITEM_TYPES = {
  REMOVABLE: 'removable'
};

const { Types, Creators } = createActions({
  setDragging: ['item']
});

export const DragTypes = Types;
export default Creators;

/* ------- Initial State --------- */
export const INITIAL_STATE = {
  item: null
};

/* ------- Selectors --------- */
export const DragSelectors = {
  selectDraggingItem: state => state.drag.item,
  selectIsRemovableDragging: state =>
    state.drag.item === DRAG_ITEM_TYPES.REMOVABLE
};

/* -------- Reducers ---------- */
export const setDraggingItem = (state, { item }) => {
  return {
    ...state,
    item
  };
};

/* -------- Hookup Reducers to Types -------- */
export const reducer = createReducer(INITIAL_STATE, {
  [Types.SET_DRAGGING]: setDraggingItem
});
